export default {
    'company': {
        label: window.i18n.__("Société"),
        bgcolor: 'dark-blue-tag',
        color: 'white',
    },
    'person': {
        label: window.i18n.__("Particulier"),
        bgcolor: 'gold-tag',
        color: 'white',
    },
    'client': {
        label: window.i18n.__("Client"),
        bgcolor: 'light-blue-tag',
        color: 'white',
    },
    'prospect': {
        label: window.i18n.__("Prospect"),
        bgcolor: 'light-purple-tag',
        color: 'white',
    },
    'supplier': {
        label: window.i18n.__("Fournisseur"),
        bgcolor: 'light-pink-tag',
        color: 'white',
    },
    'contact': {
        label: window.i18n.__("Contact"),
        bgcolor: 'dark-teal-tag',
        color: 'white',
    },
    'archived': {
        label: window.i18n.__("Archivé"),
        bgcolor: 'grey-tag',
        color: 'white',
    }
}